import React, { useState } from 'react';
import { useClientDetails } from './useClientDetails';
import { Wrapper, Content, Line, MLabel, Title, SectionHeader } from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesDown, faAnglesUp } from '@fortawesome/free-solid-svg-icons';
import Loading from 'components/Loading';
import HeaderBox from 'components/HeaderBox';
import MessageBox from 'components/MessageBox';
import BackButton from 'components/BackButton';
import SectionDetails from './Component/SectionDetails';
import ClientSalesSlip from './Component/ClientSalesSlip';


const ClientDetails = () => {
    const { clientDetails, isLoading, message, setMessage } = useClientDetails();
    const [showDetails, setShowDetails] = useState(false);
    return (<>
        {clientDetails?.ClientID && (
            <Wrapper>
                <Loading isLoading={isLoading} />
                <HeaderBox title={clientDetails?.ClientName || ""} showCart={true} />
                <MessageBox message={message} setMessage={setMessage} />
                <Content>
                    <div>
                        <SectionHeader className="border-top-3">
                            <label>お客様情報</label>
                            <input hidden id="id_showGoodsInfo" type="checkbox" onChange={() => { setShowDetails(preVal => !preVal) }} checked={showDetails} />
                            {showDetails ? <label htmlFor="id_showGoodsInfo" className="btn"><FontAwesomeIcon icon={faAnglesDown} /></label> :
                                <label htmlFor="id_showGoodsInfo" className="btn"><FontAwesomeIcon icon={faAnglesUp} /></label>
                            }
                        </SectionHeader>
                        {!!showDetails && (<SectionDetails clientDetails={clientDetails} />)}
                    </div>
                    <div>
                        <ClientSalesSlip cID={clientDetails?.ClientID} cName={clientDetails?.ClientName} />
                    </div>
                </Content>
                <BackButton />
            </Wrapper>
        )}
    </>
    )
}

export default ClientDetails;
